import ListCartHeaderInterface from '../interfaces/ListCartHeaderInterface';
import ProductTemplate from '../ProductTemplate/ProductTemplate';
import ProductHeaderInterface from '../interfaces/ProductHeaderInterface';

/**
 * Create Html element products list
 */
export default class CreateListProduct {
  public static execute(
    props: ListCartHeaderInterface,
    element: HTMLElement,
    templateElement: HTMLElement,
    deleteData: Function
  ) {
    // Clear list
    element.textContent = '';

    Object.values(props).forEach(
      (product: ProductHeaderInterface, index: number) => {
        const productElement = ProductTemplate.createProductElement(
          product.referenceId.toString(),
          props[index],
          templateElement,
          deleteData
        );

        if (productElement) {
          element.appendChild(productElement);
        }
      }
    );
  }
}
